import { render } from "./Aladda.vue?vue&type=template&id=7b89df4c&scoped=true"
import script from "./Aladda.vue?vue&type=script&lang=js"
export * from "./Aladda.vue?vue&type=script&lang=js"

import "./Aladda.vue?vue&type=style&index=0&id=7b89df4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b89df4c"]])

export default __exports__